import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import Icon from '@/components/base/Icon';

export const PreviewYoutube = ({ post }) => {
    const { t } = useTranslation('commons');

    if (post?.medias?.[0]?.no_analytics || post?.medias?.[0]?.video === null) {
        return (
            <div
                className="relative flex w-full flex-col overflow-hidden rounded-md bg-icoGray-100 p-4 dark:bg-icoDarkMode-deepBlack lg:p-16"
                aria-label="preview-youtube">
                <div className="square">
                    <div className="flex flex-col items-center justify-center rounded-md">
                        <Icon
                            className="text-xl text-icoGray-500 dark:text-icoDarkMode-wolf"
                            icon="play"
                        />
                        <p className="mt-4 text-center text-sm text-icoGray-500 dark:text-icoDarkMode-wolf">
                            {t('media_viewer.youtube_no_analytics')}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="relative mb-8 pb-[56.25%]">
            <span className="absolute block h-full w-full animate-pulse rounded-lg bg-icoGray-300 dark:bg-icoDarkMode-deepBlack" />
            <iframe
                data-testid="youtube-preview"
                width="100%"
                height="100%"
                className="absolute left-0 top-0 rounded-lg"
                src={post?.medias?.[0]?.video}
                title="preview-youtube"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
            />
        </div>
    );
};
